import React from 'react'
import { 
  Modal, 
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col
} from 'reactstrap'
import _ from 'lodash'
import NumberFormat from "react-number-format"

import LoadingOverlay from 'components/Indicator/LoadingOverlay'

import CurrencySettings from 'utils/currencies'

const Update = ({
  showUpdateProduct,
  selectedProduct,
  onChangeProductsHOC,
  onLoadProducts,
  updateProduct
}) => {

  const onChangeProductData = ( key, val ) => {
    let tmp = _.cloneDeep( selectedProduct )
    tmp[ key ] = val
    return onChangeProductsHOC( 'selectedProduct', tmp )
  }

  return (
    <Modal
      isOpen={ showUpdateProduct }
      size={ 'md' }
      toggle={() => {
        onChangeProductsHOC( 'showUpdateProduct', false )
      }}>
      <ModalHeader toggle={() => onChangeProductsHOC( 'showUpdateProduct', false )}>Update product</ModalHeader>
      <ModalBody>
        <Form onSubmit={ e => e.preventDefault()}>
          <FormGroup>
            <Label>Name</Label>
            <Input 
              type="text"
              value={ selectedProduct.name }
              onChange={ e => {
                onChangeProductData( 'name', e.target.value )
              }} />
          </FormGroup>
          <FormGroup>
            <Label>Stocks</Label>
            <Input 
              type="number"
              value={ selectedProduct.stocks }
              onChange={ e => {
                onChangeProductData( 'stocks', parseInt( e.target.value ) )
              }} />
          </FormGroup>
          <FormGroup>
            <Label>{`Price per unit - ${ CurrencySettings() }`}</Label>
            <NumberFormat
              className="form-control"
              value={ selectedProduct.price }
              thousandSeparator={ "," }
              decimalSeparator={ "." }
              onValueChange={( values ) => {
                const { formattedValue, value } = values;
                onChangeProductData( 'price', value )
              }}
              inputMode="numeric"
              displayType="input"
            />
          </FormGroup>
        </Form>
        { onLoadProducts && <LoadingOverlay /> }
      </ModalBody>
      <ModalFooter>
        <Button 
          color="primary"
          onClick={() => {
            updateProduct( selectedProduct )
          }}>
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default Update